module.exports = __webpack_public_path__ + "static/media/bg_controll_btn_left.3e424cf3.svg";